import React from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import { ISonURL } from '../../types/IUrl';
import { murmurhash } from '../../lib/js/hash';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';
import { AttributeRuleCombination, AttributeRules } from '../../_lib/components/AttributeRules/AttributeRules';
import { useTranslation } from 'react-i18next';
import { AttributeRule } from '../../types/api/AttributeGroups';

type AttributeGroupListItem = {
  link: ISonURL;
  rules: AttributeRule[];
  ruleCombination?: AttributeRuleCombination;
};

type AttributeGroupsList = {
  groups: AttributeGroupListItem[];
};

/**
 * List Of Attribute Groups and their configured rules in Portal settings.
 */
function AttributeGroupsList({ groups }: AttributeGroupsList) {
  const { t } = useTranslation('AttributeGroups');

  const transformRules = (rules: AttributeRule[]) =>
    rules.map(rule => ({
      ...rule,
      attributeName: t(`PersonAttributes:${rule.attributeName}`),
    }));

  return (
    <ContentList ordered>
      {groups.map(group => (
        <ContentListItem key={group.link.name}>
          <ContentHeadline
            title={group.link.name}
            url={group.link.url}
            hierarchy={2}
            modifier="top-headline"
            headingId={`role-list-heading-${murmurhash(group.link.url)}`}
          />
          <AttributeRules
            rules={transformRules(group.rules)}
            ruleCombination={group.ruleCombination}
            heading={t('ruleHeading')}
          />
        </ContentListItem>
      ))}
    </ContentList>
  );
}

export const AttributeGroupsListBlock = asBlock(AttributeGroupsList, BlockType.attributegroupslist);
